import { render } from "./PlotRentDemandNotice.vue?vue&type=template&id=21d60768&scoped=true"
import script from "./PlotRentDemandNotice.vue?vue&type=script&lang=js"
export * from "./PlotRentDemandNotice.vue?vue&type=script&lang=js"

import "./PlotRentDemandNotice.vue?vue&type=style&index=0&id=21d60768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d60768"]])

export default __exports__